import { render, staticRenderFns } from "./allBatchBulk.vue?vue&type=template&id=153435f2"
import script from "./allBatchBulk.vue?vue&type=script&lang=ts"
export * from "./allBatchBulk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports